import del from './delete';
import get from './get';
import put from './put';
import source from './source';
import test from './test';

export default {
  del,
  get,
  put,
  source,
  test,
};
